var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartFull = function SvgHeartFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 38c-.1 0-.3 0-.4-.1-.2-.1-3.8-2.1-7.5-5.5-2.2-2-3.9-4-5.2-6-1.6-2.6-2.4-5.1-2.4-7.6 0-4.7 3.9-8.6 8.6-8.6 1.6 0 3.3.6 4.8 1.7.9.6 1.6 1.4 2.2 2.2.5-.8 1.3-1.6 2.2-2.2 1.5-1.1 3.2-1.7 4.8-1.7 4.7 0 8.6 3.9 8.6 8.6 0 2.5-.8 5.1-2.4 7.6-1.3 2-3 4-5.2 6-3.7 3.3-7.4 5.4-7.5 5.5-.3.1-.5.1-.6.1z"
  })));
};
export default SvgHeartFull;